import { SortEnum } from '@pylot-data/enums/SortEnum'
import { SORT_LABELS } from '@pylot-data/constants/plp'
import { getSortingLabel } from '@pylot-data/api/utils/sortingLabels'
import detectPageBuilder from '@corratech/pylot-rich-content/src/PageBuilder/detectPageBuilder'
import parsePageBuilderData from '@corratech/pylot-rich-content/src/PageBuilder/parseStorageHtml'

export const getPreParsedPageBuilderData = (html?: string | null) => {
    if (!html || !detectPageBuilder(html)) return null
    return parsePageBuilderData(html)
}

export const shouldUsePreParsedPageBuilder = (
    currentHtml: string | null | undefined,
    initialHtml: string | null | undefined,
    pageBuilderData: unknown
): boolean =>
    Boolean(
        pageBuilderData &&
        currentHtml != null &&
        initialHtml != null &&
        currentHtml === initialHtml
    )

export const getDefaultSort = (defaultSortBy: string | null) => {
    if (!defaultSortBy) return { sort: {}, label: 'Nuevo' }

    switch (defaultSortBy) {
        case 'price_asc':
            return {
                sort: { price_asc: SortEnum.Asc },
                label: SORT_LABELS.price_asc
            }
        case 'price_desc':
            return {
                sort: { price_desc: SortEnum.Desc },
                label: SORT_LABELS.price_desc
            }
        case 'name':
            return { sort: { name: SortEnum.Asc }, label: SORT_LABELS.name }
        case 'new':
            return { sort: { new: SortEnum.Desc }, label: SORT_LABELS.new }
        case 'saving':
            return { sort: { saving: SortEnum.Asc }, label: SORT_LABELS.saving }
        case 'position':
            return {
                sort: { position: SortEnum.Asc },
                label: SORT_LABELS.position
            }
        default:
            return { sort: {}, label: 'Nuevo' }
    }
}

export const shouldDisplayLoading = (
    currentPageNumber: number,
    isSorting: boolean,
    isFiltering: boolean,
    isLoadingProducts: boolean,
    isProductsValidating: boolean,
    isGridReflowing: boolean
) => {
    return (
        ((currentPageNumber !== 1 || isSorting || isFiltering) &&
            isLoadingProducts &&
            isProductsValidating) ||
        isGridReflowing
    )
}

export const calculateCategoryMetadata = (
    productsResult: any,
    categoryInitialData: any,
    productsToRender: any[]
) => {
    const totalProducts =
        productsResult?.total_count ??
        categoryInitialData?.products?.total_count ??
        0
    const renderedCount = productsToRender?.length || 0
    const amountBarWidth = (renderedCount / totalProducts) * 100 || 0

    return { totalProducts, renderedCount, amountBarWidth }
}

/**
 * Etiqueta del orden activo (p. ej. restaurado desde `?sort=`). Si el valor no
 * está en los mapas conocidos se conserva la etiqueta actual.
 */
export const getSortLabel = (
    sort: Record<string, unknown> | null | undefined,
    fallback = 'Nuevo'
): string => {
    const key = sort
        ? Object.keys(sort).find((k) => Boolean(sort[k]))
        : undefined
    if (!key) return fallback
    return (
        getSortingLabel(key) ??
        (SORT_LABELS as Record<string, string>)[key] ??
        fallback
    )
}

/**
 * Magento 2.4.8 removió `CategoryTree.id`; el id numérico se deriva del uid
 * (base64). Un uid malformado no debe romper el render de la PLP.
 */
export const decodeCategoryId = (
    uid: string | null | undefined
): string | undefined => {
    if (!uid) return undefined
    try {
        return atob(uid)
    } catch {
        return undefined
    }
}
